import {
    ApinormalBet,
    ApigetAllLotteryList,
    ApigetCanChasePeriods,
    ApigetLotteryList
} from "@api/service";
export default {
    namespaced: true,
    state: {
        activeAnimal: [], //当前选择的生肖
        //玩法树
        playwayTree: [],
        //玩法树缓存
        fixedPlaywayTree: [],
        //所有彩票
        lotteryList: [],
        // 彩种大类
        lotteryTypeSet: [],
        lotteryOfficialType: [],
        lotteryCreditType: [],
        // 标签大类
        lotteryTagType: [],
        lotteryOfficialTagType: [],
        lotteryCreditTagType: [],
        //当前彩种大类
        lotteryTypeCode: "SSC",
        //当前彩种
        lotteryCode: "FFC",
        tagCode: '',
        //当前选择的玩法组
        playwayGroupCurrent: {},
        //当前选中的具体玩法
        playwayCurrent: {},
        //当前所选总注数
        betCount: 0,
        //选号页面当前所选号码数组
        selectArr: [],
        //当前选中号数组 选定数字后加到这个数组中
        lotteryOrderList: [],
        //当前玩法配置
        playwayConfig: {},
        //订单下注倍数
        betMultiple: "1",
        //反水当前值
        rpRateCurrent: 0,
        //反水当前值MAX
        rpRateCurrentMax: 0,
        //当前所选号码最高赔率
        memRewardSeek: {},
        //单注金额
        completeUnitAmount: 2,
        //任选定位 ['W','Q']
        position: null,
        //任选定位 最少选择位数
        minPosition: 0,
        //20S获取一次开奖号码的计时器
        lotteryLatelyLpVoTimer: null,
        //所有彩种的开奖列表
        LotteryLatelyLpVo: [],
        LotteryLatelyLpVoTag: [],
        //当前期号
        periodsNumber: "",
        //选号状态
        chaseStatu: false,
        //可追号的期数
        periodsNumberList: [],
        //是否需要更新新的可追号期数
        needUpdateChasePeriods: true,
        simplexValue: "",
        //信用玩法的
        //特码包三
        TMBSArr: [],
        //信用选号页面当前所选号码数组
        creditSelectArr: [],
        //信用玩法表单数据
        orderDetailFormList: [],
        //信用玩法下注方式 0 快捷 1一般
        creditMode: 0,
        //下注圆角分
        mode: 1,
        latelyDrawedPeriods: [],
        //亚博彩票信用
        unitAmountList: [],
        defaultUnitAmountList: [10, 50, 100, 500],
        isShowShopingcar: false,
        isShowCreditConfirm: false,
        lotteryShopingCarList: [],
        //官方
        isShowPurchaseShopingcar: false,
        isShowPurchaseConfirm: false,
        isShowLotteryChasePop: false,
        lotteryChaseOrderList: [],
        needUpdatePeriods: false,
        isShowLotteryChasePopFrom: 'bet',
        // 股指走势下拉窗
        gzPopShow: false,
        betPeriodsNumberOld: "",//点击投注时候的期号
        tabBarIndex: 0,//用来处理LHC信用玩法快捷快捷生肖的正特处理

        modelDfcp: 0,//大发彩票信用 官方玩法  
        levalTree2Dfcp: [],//大发玩法2及菜单
        seekLoading: true,//控制玩法切换频率
        statu: 0,
        showSuccessModel: false,
        dafacpLotteryHistoryList: [],//处理大发历史记录列表 不能公用以前的历史数据

    },
    getters: {
        activeAnimal(state) {
            return state.activeAnimal;
        },
        lottery_11X5(state) {
            return state.lotteryList.filter((e) => e.lotteryTypeCode == "11X5");
        },
        lottery_K3(state) {
            return state.lotteryList.filter((e) => e.lotteryTypeCode == "K3");
        },
        lottery_PK10(state) {
            return state.lotteryList.filter((e) => e.lotteryTypeCode == "PK10");
        },
        lottery_SSC(state) {
            return state.lotteryList.filter((e) => e.lotteryTypeCode == "SSC");
        },
        lottery_LHC(state) {
            return state.lotteryList.filter((e) => e.lotteryTypeCode == "LHC");
        },
        lottery_PCDD(state) {
            return state.lotteryList.filter((e) => e.lotteryTypeCode == "PCDD");
        },
        lottery_3D(state) {
            return state.lotteryList.filter((e) => e.lotteryTypeCode == "3D");
        },
        lottery_PL3(state) {
            return state.lotteryList.filter((e) => e.lotteryTypeCode == "PL3");
        },
        lotteryList(state, getters, rootState) {
            let newList = []
            state.lotteryTypeSet.forEach((type) => {
                let obj = Object.assign({}, {
                    ...type
                })
                obj.list = state.lotteryList.filter((e) => e.lotteryTypeCode == type.lotteryTypeCode) || []
                newList.push(obj);
            });
            return newList;
        },
        GFHotlotteryList(state, getters, rootState) {
            let lotteryOfficialType = state.lotteryList.slice().sort((a, b) => a.orderNum - b.orderNum);
            let newList = lotteryOfficialType.filter((e) => e.isHot == 1 && e.supportPlayway != 2)
            return newList;
        },
        XYHotlotteryList(state, getters, rootState) {
            let lotteryCreditType = state.lotteryList.slice().sort((a, b) => a.orderNum - b.orderNum);
            let newList = lotteryCreditType.filter((e) => e.isHot == 1 && e.supportPlayway != 1)
            return newList;
        },
        NewGFHotlotteryList(state, getters, rootState) {
            let lotteryOfficialType = state.lotteryList.slice().sort((a, b) => a.orderNum - b.orderNum);
            let newList = lotteryOfficialType.filter((e) => e.isHot == 1 && e.supportPlayway != 2)
            return newList;
        },
        NewXYHotlotteryList(state, getters, rootState) {
            let lotteryCreditType = state.lotteryList.slice().sort((a, b) => a.orderNum - b.orderNum);
            let newList = lotteryCreditType.filter((e) => e.isHot == 1 && e.supportPlayway != 1)
            return newList;
        },
        GFlotteryList(state, getters, rootState) {
            let newList = [];

            state.lotteryOfficialType.forEach((type) => {
                let obj = Object.assign({}, {
                    ...type
                })
                obj.list = state.lotteryList.filter((e) => e.lotteryTypeCode == type.lotteryTypeCode && e.supportPlayway != 2) || []
                newList.push(obj);
            });
            return newList;
        },
        XYlotteryList(state, getters, rootState) {
            let newList = []
            state.lotteryCreditType.forEach((type) => {
                let obj = Object.assign({}, {
                    ...type
                })
                obj.list = state.lotteryList.filter((e) => e.lotteryTypeCode == type.lotteryTypeCode && e.supportPlayway != 1) || []
                newList.push(obj);
            });
            return newList;
        },
    },
    mutations: {
        setactiveAnimal(state, animal) {
            state.activeAnimal = animal;
        },
        //清除所有数据
        clear(state) {
            state.betCount = 0;
            state.selectArr = [];
            state.lotteryOrderList = [];
            state.simplexValue = "";
            state.TMBSArr = [];
            state.creditSelectArr = [];
            state.orderDetailFormList = [];
        },
        //设置任选定位
        setposition(state, payload) {
            let arr = ["W", "Q", "B", "S", "G"];
            let newList = [];

            if (payload instanceof Array) {
                arr.forEach((e, index) => {
                    if (payload.includes(arr[index])) newList.push(arr[index]);
                });
            } else {
                newList = null;
            }
            state.position = newList;
        },
        setgzPopShow(state, payload) {
            state.gzPopShow = payload;
        },
        //设置当前追号状态 教练我想追号！
        setchaseStatu(state, payload) {
            state.chaseStatu = payload;
        },
        setisShowLotteryChasePopFrom(state, payload) {
            state.isShowLotteryChasePopFrom = payload;
        },
        setneedUpdatePeriods(state, payload) {
            state.needUpdatePeriods = payload;
        },
        setlotteryChaseOrderList(state, payload) {
            state.lotteryChaseOrderList = payload;
        },
        setisShowLotteryChasePop(state, payload) {
            state.isShowLotteryChasePop = payload;
        },
        setisShowPurchaseShopingcar(state, payload) {
            state.isShowPurchaseShopingcar = payload;
        },
        setisShowCreditConfirm(state, payload) {
            state.isShowCreditConfirm = payload;
        },
        setBetPeriodsNumber(state, payload) {
            state.betPeriodsNumberOld = payload;
        },
        setisShowPurchaseConfirm(state, payload) {
            state.isShowPurchaseConfirm = payload;
        },
        setlotteryShopingCarList(state, payload) {
            state.lotteryShopingCarList = payload;
        },
        setisShowShopingcar(state, payload) {
            state.isShowShopingcar = payload;
        },
        setunitAmountList(state, payload) {
            state.unitAmountList = payload;
        },
        setMode(state, payload) {
            state.mode = payload;
        },
        setcreditSelectArr(state, payload) {
            state.creditSelectArr = payload;
        },
        setTMBSArr(state, payload) {
            state.TMBSArr = payload;
        },
        setorderDetailFormList(state, payload) {
            state.orderDetailFormList = payload;
        },
        setcreditMode(state, payload) {
            state.creditMode = payload;
        },
        setmemRewardSeek(state, payload) {
            state.memRewardSeek = payload;
        },
        //设置 是否需要更新新的可追号期数
        setneedUpdateChasePeriods(state, payload) {
            state.needUpdateChasePeriods = payload;
        },
        //设置当前期号
        setperiodsNumber(state, payload) {
            state.periodsNumber = payload;
        },
        setsimplexValue(state, payload) {
            state.simplexValue = payload;
        },
        //设置任选定位最少位置
        setminPosition(state, payload) {
            state.minPosition = payload;
        },
        //订单下注倍数
        setbetMultiple(state, payload) {
            state.betMultiple = payload;
        },
        //设置反水当前值
        setrpRateCurrent(state, payload) {
            state.rpRateCurrent = payload;
        },
        //设置反水当前值
        setrpRateCurrentMax(state, payload) {
            state.rpRateCurrentMax = payload;
        },
        //设置单注金额
        setcompleteUnitAmount(state, payload) {
            state.completeUnitAmount = payload;
        },
        //设置彩种大类
        setlotteryTypeCode(state, payload) {
            state.lotteryTypeCode = payload;
        },
        //设置彩种
        setlotteryCode(state, payload) {
            state.lotteryCode = payload;
        },
        //设置分类
        settagCode(state, payload) {
            state.tagCode = payload;
        },
        //设置当前玩法
        setplaywayTree(state, payload) {
            state.playwayTree = payload;
        },
        //设置当前玩法
        setplaywayCurrent(state, payload) {
            state.playwayCurrent = payload;
        },
        //设置当前玩法组
        setplaywayGroupCurrent(state, payload) {
            state.playwayGroupCurrent = payload;
        },
        setlotteryBetCount(state, payload) {
            state.betCount = payload;
        },
        setlotterySelectArr(state, payload) {
            state.selectArr = payload;
        },
        //添加购物车数组
        pushlotteryOrderList(state, payload) {
            state.lotteryOrderList.push(payload);
        },
        //合并新的数组到购物车数组
        concatlotteryOrderList(state, payload) {
            state.lotteryOrderList = state.lotteryOrderList.concat(payload);
        },
        //设置购物车数组
        setlotteryOrderList(state, payload) {
            state.lotteryOrderList = [...payload];
            if (payload.length == 0) {
                state.chaseStatu = false;
            }
        },
        updateLotteryOrderList(state, payload) {
            state.lotteryOrderList.splice(payload.index, 1, payload.content)
            // Vue.set(state.lotteryOrderList,payload.index,payload.content)
        },
        //设置玩法配置
        setplaywayConfig(state, payload) {
            state.playwayConfig = payload;
        },
        //设置彩种开奖计时器
        setLotteryLatelyTimer(state, payload) {
            console.log("5:设置新的彩种开奖计时器vuex", payload);
            state.lotteryLatelyLpVoTimer = payload;
        },
        //清除获取彩种开奖计时器
        clearLotteryLatelyTimer(state) {
            console.log("1:清除循环获取彩种开奖列表的计时器" + state.lotteryLatelyLpVoTimer);
            clearInterval(state.lotteryLatelyLpVoTimer);
            console.log("2:计时器不在了···" + state.lotteryLatelyLpVoTimer);
        },
        //设置彩种开奖列表
        setLotteryLatelyLpVo(state, payload) {
            state.LotteryLatelyLpVo = payload;
        },
        setLotteryLatelyLpVoTag(state, payload) {
            state.LotteryLatelyLpVoTag = payload;
        },
        //设置可追号的期数
        setperiodsNumberList(state, payload) {
            state.periodsNumberList = payload;
        },
        //设置所有彩票列表
        setlotteryList(state, payload) {
            state.lotteryList = payload;
        },
        setLotteryTypeSet(state, payload) {
            state.lotteryTypeSet = payload;
        },
        setlotteryOfficialType(state, payload) {
            state.lotteryOfficialType = payload;
        },
        setlotteryCreditType(state, payload) {
            state.lotteryCreditType = payload;
        },
        setLotteryTagType(state, payload) {
            state.lotteryTagType = payload;
        },
        setlotteryOfficialTagType(state, payload) {
            state.lotteryOfficialTagType = payload;
        },
        setlotteryCreditTagType(state, payload) {
            state.lotteryCreditTagType = payload;
        },
        setLatelyDrawedPeriods(state, payload) {
            state.latelyDrawedPeriods = payload;
        },
        //设置大发彩票版面玩法
        setModelDfcp(state, payload) {
            state.modelDfcp = payload;
        },
        //设置大发彩票2及菜单
        setLevalTree2Dfcp(state, payload) {
            state.levalTree2Dfcp = payload;
        },
        setFixedPlaywayTree(state, payload) {
            state.fixedPlaywayTree = payload;
        },
        setSeekLoading(state, payload) {
            state.seekLoading = payload;
        },
        setStatu(state, payload) {
            state.statu = payload;
        },
        setshowSuccessModel(state, payload) {
            state.showSuccessModel = payload;
        },
        setdafacpLotteryHistoryList(state, payload) {
            state.dafacpLotteryHistoryList = payload;
        },
        setTabBarIndex(state, payload) {
            state.tabBarIndex = payload
        },

    },
    actions: {
        //普通下注 param 为数组
        normalBet({
            state,
            commit,
            dispatch
        }, param = state.lotteryOrderList) {
            return new Promise((resolve, reject) => {
                ApinormalBet({
                    lotteryCode: state.lotteryCode,
                    orderDetailFormList: param,
                    orderType: 0,
                }).then((res) => {
                    if (res.code == "12200") {
                        dispatch("user/getBalance", "", {
                            root: true
                        });
                        resolve(res);
                    } else {
                        resolve(res);
                    }
                });
            });
        },
        //获取彩种开奖列表
        getLotteryLatelyLpVo({
            state,
            commit,
            dispatch,
            rootState
        }) {
            return new Promise(async (resolve, reject) => {
                let res = await ApigetAllLotteryList();
                if (res.code == "12200") {
                    let mixLotterylist = []
                    let LotteryLatelyLpVoTag = []
                    let list = res.data;
                    list.forEach((item) => {
                        let status = Vue.prototype.$tools.whatIsNextlotteryStatu(item)
                        let lotteryDetail = state.lotteryList.find(eleLottery => eleLottery.lotteryCode == item.lotteryCode)
                        mixLotterylist.push({
                            ...item,
                            ...lotteryDetail,
                            status
                        })
                    });
                    commit("setLotteryLatelyLpVo", mixLotterylist);
                    console.log("4:更新开奖时间列表");
                    const lotteryShowStyle = rootState.sysParameter.lottery_type_show_style;
                    if (lotteryShowStyle) {
                        res.data.forEach(lottery => {
                            let haveTagLottery = state.lotteryList.find(eleLottery => eleLottery.lotteryCode == lottery.lotteryCode)
                            if (haveTagLottery) {
                                let showTags = JSON.parse(haveTagLottery.showTags)
                                if (typeof (showTags) == 'object') {
                                    showTags.forEach(tag => {
                                        let innerElement = Object.assign({}, lottery, {
                                            tagCode: tag.tagCode,
                                            tagName: tag.tagName,
                                            smallSort: Number(tag.smallSort)
                                        })
                                        if (!LotteryLatelyLpVoTag.some((xitem) => xitem.tagCode == tag.tagCode)) {
                                            let outElement = Object.assign({},
                                                lottery, {
                                                tagCode: tag.tagCode,
                                                tagName: tag.tagName,
                                                bigSort: Number(tag.bigSort),
                                                list: [{
                                                    ...innerElement
                                                }]
                                            }
                                            )
                                            LotteryLatelyLpVoTag.push(outElement);
                                        } else {
                                            let shotEle = LotteryLatelyLpVoTag.find(outEle => outEle.tagCode == tag.tagCode)
                                            shotEle.list.push(innerElement)
                                            shotEle.list.sort((a, b) => a.smallSort - b.smallSort);
                                        }
                                    })
                                    // 标签大类排序
                                    LotteryLatelyLpVoTag.sort((a, b) => a.bigSort - b.bigSort);
                                    // console.log('LotteryLatelyLpVoTag', LotteryLatelyLpVoTag)
                                    commit("setLotteryLatelyLpVoTag", LotteryLatelyLpVoTag);
                                }
                            }
                        })

                    }
                }
                resolve(res);
            });
        },
        //获取当前可追期数
        getCanChasePeriods({
            state,
            commit
        }) {
            return new Promise((resolve, reject) => {
                ApigetCanChasePeriods({
                    lotteryCode: state.lotteryCode,
                    num: 30,
                }).then((res) => {
                    if (res.code == "12200") {
                        res.data.forEach((e) => {
                            e.checked = false;
                            e.chaseMultiplier = 1;
                        });
                        commit("setperiodsNumberList", res.data);
                    }
                    resolve(res);
                });
            });
        },
        getLotteryLatelyLoop({
            state,
            dispatch,
            commit
        }) {
            return new Promise((resolve, reject) => {
                //循环获取彩种开奖列表
                let res = dispatch("getLotteryLatelyLpVo").then(() => {
                    clearInterval(state.lotteryLatelyLpVoTimer);
                    state.lotteryLatelyLpVoTimer = setInterval(() => {
                        dispatch("getLotteryLatelyLpVo");
                        dispatch("service/getServiceTime", false, {
                            root: true
                        });
                    }, 10000);

                    resolve(res);
                });
            });
        },
        getLotteryList({
            state,
            commit,
            rootState
        }) {
            //缓存 只取一次
            return new Promise(async (resolve, reject) => {
                // if (state.lotteryList.length != 0) {
                //     resolve(state.lotteryList)
                //     return;
                // }

                let res = await ApigetLotteryList();
                if (res.code == "12200") {
                    const lottery_config = rootState.app.appConfig.lottery_config.configValue;
                    const lotteryShowStyle = rootState.sysParameter.lottery_type_show_style;
                    console.log('是否显示标签分类', lotteryShowStyle)
                    //根据配置将不支持的彩票移除
                    let _list = res.data;

                    // 标签大类
                    let lotteryTagType = []
                    let lotteryOfficialTagType = []
                    let lotteryCreditTagType = []
                    if (lotteryShowStyle) {
                        _list.forEach(lottery => {
                            let showTags = JSON.parse(lottery.showTags)
                            if (typeof (showTags) == 'object') {
                                showTags.forEach(tag => {
                                    let innerElement = Object.assign({}, lottery, {
                                        tagCode: tag.tagCode,
                                        tagName: tag.tagName,
                                        smallSort: Number(tag.smallSort)
                                    })
                                    // 分组大类
                                    if (!lotteryTagType.some((xitem) => xitem.tagCode == tag.tagCode)) {
                                        let outElement = Object.assign({},
                                            lottery, {
                                            tagCode: tag.tagCode,
                                            tagName: tag.tagName,
                                            bigSort: Number(tag.bigSort),
                                            list: [{
                                                ...innerElement
                                            }]
                                        }
                                        )
                                        lotteryTagType.push(outElement);
                                    } else {
                                        let shotEle = lotteryTagType.find(outEle => outEle.tagCode == tag.tagCode)
                                        shotEle.list.push(innerElement)
                                        shotEle.list.sort((a, b) => a.smallSort - b.smallSort);
                                    }
                                    // 官方分组大类
                                    if (!lotteryOfficialTagType.some((xitem) => xitem.tagCode == tag.tagCode) && lottery.supportPlayway != 2) {
                                        let outElement = Object.assign({},
                                            lottery, {
                                            tagCode: tag.tagCode,
                                            tagName: tag.tagName,
                                            bigSort: Number(tag.bigSort),
                                            list: [{
                                                ...innerElement
                                            }]
                                        }
                                        )
                                        lotteryOfficialTagType.push(outElement);
                                    } else {
                                        if (innerElement.supportPlayway != 2) {
                                            let shotEle = lotteryOfficialTagType.find(outEle => outEle.tagCode == tag.tagCode)
                                            shotEle.list.push(innerElement)
                                            shotEle.list.sort((a, b) => a.smallSort - b.smallSort);
                                        }
                                    }
                                    // 信用分组大类
                                    if (!lotteryCreditTagType.some((xitem) => xitem.tagCode == tag.tagCode) && lottery.supportPlayway != 1) {
                                        let outElement = Object.assign({},
                                            lottery, {
                                            tagCode: tag.tagCode,
                                            tagName: tag.tagName,
                                            bigSort: Number(tag.bigSort),
                                            list: [{
                                                ...innerElement
                                            }]
                                        }
                                        )
                                        lotteryCreditTagType.push(outElement);
                                    } else {
                                        if (innerElement.supportPlayway != 1) {
                                            let shotEle = lotteryCreditTagType.find(outEle => outEle.tagCode == tag.tagCode)
                                            shotEle.list.push(innerElement)
                                            shotEle.list.sort((a, b) => a.smallSort - b.smallSort);
                                        }
                                    }
                                })
                            }
                        })
                        // 标签大类排序
                        lotteryTagType.sort((a, b) => a.bigSort - b.bigSort);
                        lotteryOfficialTagType.sort((a, b) => a.bigSort - b.bigSort);
                        lotteryCreditTagType.sort((a, b) => a.bigSort - b.bigSort);
                        commit("setLotteryTagType", lotteryTagType);
                        commit("setlotteryOfficialTagType", lotteryOfficialTagType);
                        commit("setlotteryCreditTagType", lotteryCreditTagType);
                    }

                    //排序
                    const _sortList = [..._list.sort((a, b) => a.orderNum - b.orderNum)];
                    let _sortTypeList = _list.sort((a, b) => a.lotteryTypeOrderNum - b.lotteryTypeOrderNum);
                    //大类排序
                    let LotteryTypeSet = [];
                    //官方大类。
                    let lotteryOfficialType = [];
                    //信用大类。
                    let lotteryCreditType = [];

                    _sortTypeList.forEach((item) => {
                        if (!LotteryTypeSet.some((xitem) => xitem.lotteryTypeCode == item.lotteryTypeCode)) {
                            LotteryTypeSet.push(Object.assign({}, item));
                        }
                        if (!lotteryOfficialType.some((xitem) => xitem.lotteryTypeCode == item.lotteryTypeCode) && item.supportPlayway != 2) {
                            lotteryOfficialType.push(item);
                        }
                        if (!lotteryCreditType.some((xitem) => xitem.lotteryTypeCode == item.lotteryTypeCode) && item.supportPlayway != 1) {
                            lotteryCreditType.push(item);
                        }
                    });
                    commit("setLotteryTypeSet", LotteryTypeSet);
                    commit("setlotteryOfficialType", lotteryOfficialType);
                    commit("setlotteryCreditType", lotteryCreditType);
                    commit("setlotteryList", _sortList);
                    resolve(_sortList);
                    return;
                }
                resolve([]);
            });
        },
    },
};